import { VerificationStatus } from "shared/types";
import { EmptyCellIcon } from "./TableBodySections/components/EmptyCellIcon";

export const CanadianCriminalReportStatus = ({
  status
}: {
  status: VerificationStatus;
}) => {
  if (status === VerificationStatus.Finished)
    return <p className="text-content-1000 text-sm font-medium">Done</p>;

  if (status === VerificationStatus.Skipped)
    return (
      <p className="text-content-200 text-sm font-medium">
        Wasn’t a Canadian resident
      </p>
    );

  return <EmptyCellIcon />;
};
